import BoxTitleWrapper from './boxTitle';
import { BoxWrapper } from './box.style';

export default function Box(props) {
  return (
    <BoxWrapper className="isoBoxWrapper">
      <BoxTitleWrapper title={props.title} subtitle={props.subtitle} style={props.style} />
      {props.children}
    </BoxWrapper>
  );
}